import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Vision_Mission.css";

const Vision_Mission = () => {
  return (
    <section className="vision_mission_section">
      <Container>
        {/* Mission Section */}
        <div className="mission_row">
          <Row className="align-items-center">
            <Col md={6} sm={12}>
              <div className="image_holder">
                <img
                  src="/assets/images/about_us/vision_mission/mission.png"
                  alt="Our Mission"
                  className="mission_image"
                />
              </div>
            </Col>

            <Col md={5} sm={12}>
              <div className="text_col">
                <h2 className="head_div">Our Mission</h2>
                <p className="txt_hold">
                  Our mission is to empower every driver with safe, smart, and
                  efficient driving solutions. We aim to make driving easier,
                  safer, and more accessible through innovative technology,
                  real-time assistance, and user-friendly experiences that help
                  drivers stay confident and connected on the road.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        {/* Vision Section */}
        <div className="vision_row">
          <Row className="align-items-center flex-md-row-reverse">
            <Col md={6} sm={12}>
              <div className="image_holder">
                <img
                  src="/assets/images/about_us/vision_mission/vision.png"
                  alt="Our Vision"
                  className="vision_image"
                />
              </div>
            </Col>

            <Col md={5} sm={12}>
              <div className="text_col">
                <h2 className="head_div">Our Vision</h2>
                <p className="txt_hold">
                  Our vision is to become the most trusted driving companion —
                  transforming the way people learn, drive, and travel by
                  building a connected ecosystem that promotes road safety,
                  responsibility, and sustainability for a smarter mobility
                  future.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Vision_Mission;
